var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCustomerIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "building-07"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M7.5 10H4.6C4.03995 10 3.75992 10 3.54601 10.109C3.35785 10.2049 3.20487 10.3578 3.10899 10.546C3 10.7599 3 11.0399 3 11.6V20M16.5 10H19.4C19.9601 10 20.2401 10 20.454 10.109C20.6422 10.2049 20.7951 10.3578 20.891 10.546C21 10.7599 21 11.0399 21 11.6V20M16.5 20V5.2C16.5 4.0799 16.5 3.51984 16.282 3.09202C16.0903 2.71569 15.7843 2.40973 15.408 2.21799C14.9802 2 14.4201 2 13.3 2H10.7C9.57989 2 9.01984 2 8.59202 2.21799C8.21569 2.40973 7.90973 2.71569 7.71799 3.09202C7.5 3.51984 7.5 4.0799 7.5 5.2V20M22 20H2M11 6H13M11 10H13M11 14H13",
    stroke: "#F7F9F9",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCustomerIcon);
export default __webpack_public_path__ + "static/media/add-customer-icon.033f7ae9f3319b0915ef12da6cf207af.svg";
export { ForwardRef as ReactComponent };